import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { submitEnquiry } from "@/lib/api";

const REQUIREMENTS = ["IT Recruitment", "Non-IT Recruitment", "Leadership Hiring", "Volume Hiring", "End-to-End Recruitment", "Other"];

const EMPTY = { name: "", company: "", email: "", phone: "", requirement: "IT Recruitment", positions: "", location: "", message: "" };

export default function EmployerForm({ compact = false }) {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitEnquiry(form);
      toast.success("Requirement received. Our recruitment specialists will reach out shortly.");
      setForm(EMPTY);
    } catch {
      toast.error("Something went wrong. Please try again or email hello@talentifyhs.com.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form data-testid="employer-enquiry-form" onSubmit={onSubmit} className="space-y-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <input data-testid="employer-name-input" required value={form.name} onChange={set("name")} placeholder="Name *" className="input-dark" aria-label="Name" />
        <input data-testid="employer-company-input" required value={form.company} onChange={set("company")} placeholder="Company Name *" className="input-dark" aria-label="Company Name" />
        <input data-testid="employer-email-input" required type="email" value={form.email} onChange={set("email")} placeholder="Work Email *" className="input-dark" aria-label="Work Email" />
        <input data-testid="employer-phone-input" required type="tel" value={form.phone} onChange={set("phone")} placeholder="Phone Number *" className="input-dark" aria-label="Phone Number" />
        <select data-testid="employer-requirement-select" value={form.requirement} onChange={set("requirement")} className="input-dark appearance-none" aria-label="Hiring Requirement">
          {REQUIREMENTS.map((r) => (
            <option key={r} value={r} className="bg-[#0A0F1D]">{r}</option>
          ))}
        </select>
        <input data-testid="employer-positions-input" required value={form.positions} onChange={set("positions")} placeholder="Number of Positions *" className="input-dark" aria-label="Number of Positions" />
        <input data-testid="employer-location-input" required value={form.location} onChange={set("location")} placeholder="Location *" className={`input-dark ${compact ? "" : "sm:col-span-2"}`} aria-label="Location" />
      </div>
      <textarea data-testid="employer-message-input" value={form.message} onChange={set("message")} placeholder="Message — tell us about the role, team and timelines" rows={4} className="input-dark resize-none" aria-label="Message" />
      <button
        data-testid="employer-form-submit-button"
        type="submit"
        disabled={loading}
        className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-blue-600 px-7 py-3.5 text-sm font-semibold text-white shadow-[0_8px_30px_rgba(37,99,235,0.35)] transition-[background-color,box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:bg-blue-500 disabled:opacity-60 sm:w-auto"
      >
        {loading ? <Loader2 size={16} className="animate-spin" /> : <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />}
        {loading ? "Submitting..." : "Submit Requirement"}
      </button>
    </form>
  );
}
